import { createContext, useContext, useMemo } from 'react';

// This context should have all the variables used in the card location query
import { jsx as _jsx } from "react/jsx-runtime";
const CardLocationContext = /*#__PURE__*/createContext({
  additionalLocationData: {
    objectId: undefined,
    objectTypeId: undefined
  },
  features: new Set(),
  location: 'UNKNOWN',
  propertySource: 'CRM_UI',
  usageTracker: undefined,
  standaloneUsageTracker: undefined,
  enableVirtualization: false,
  updatedAt: undefined
});
export function CardLocationContextProvider({
  value,
  children
}) {
  const valueWithStandaloneUsageTracker = useMemo(() => {
    var _value$usageTracker;
    if (value !== null && value !== void 0 && (_value$usageTracker = value.usageTracker) !== null && _value$usageTracker !== void 0 && _value$usageTracker.clone) {
      return Object.assign({
        standaloneUsageTracker: value.usageTracker.clone({
          standalone: true
        })
      }, value);
    }
    return value;
  }, [value]);
  return /*#__PURE__*/_jsx(CardLocationContext.Provider, {
    value: valueWithStandaloneUsageTracker,
    children: children
  });
}
export const useCardLocationContext = () => useContext(CardLocationContext);